import {utils} from "@mc/mc-legacy";
const {ErrorApi, ParamsFetch} = utils;

/**
 * Ručně psané API z důvodu nevygenerovatelného @RequestPart
 */
export default class ObjednavkaCustomApi {

    static createTempSoubory(soubory) {
        const uri = serverContextPath + `/api/cgo/objednavka/soubory`;
        const headers = new Headers();

        const data = new FormData();
        if (soubory && Array.isArray(soubory)) {
            for (let item of soubory) {
                data.append("soubory", item);
            }
        }

        return ErrorApi.responseResolver(ParamsFetch.put(uri, null, data, headers));
    }

}
